import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './start.content.json';

/**
 * @module StartModule
 * @ngdoc component
 * @name StartComponent
 */
@Component({
    selector: 'tokens-browser-start',
    templateUrl: 'start.component.html',
    standalone: false
})
export class StartComponent implements OnInit {
    @Input()
    public allowDigipas: boolean;

    @Input()
    public browserName: string;

    @Output()
    public next: EventEmitter<string> = new EventEmitter();

    @Output()
    public back: EventEmitter<void> = new EventEmitter();

    public browserNameParams = { browserName: '' };

    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.browserNameParams.browserName = this.browserName || '';
    }

    public onNext(): void {
        this.next.emit();
    }

    public onBack(): void {
        this.back.emit();
    }

    public getAdviceStepsContent(): string {
        const allowDigipas = this.allowDigipas ? 'allowed' : 'disallowed';
        return `tokens.browser.start.content.advice.steps.digipas.${allowDigipas}`;
    }
}
